import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: 'zhaopin',
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      component: () => import('@/views/home')
    },
    {
      path: '/login',
      component: () => import('@/views/login')
    },
    {
      path: '/register',
      component: () => import('@/views/register')
    },
    {
      path: '/changePass',
      component: () => import('@/views/changePass')
    },
    {
      path: '/announcement',
      name: 'notice',
      component: () => import('@/views/Announcement/index')
    },
    {
      path: '/announcement/article',
      name: 'notice_detail',
      component: () => import('@/views/Announcement/article')
    },
    {
      path: '/personal/center',
      name: 'center',
      component: () => import('@/views/Personal/center'),
      meta: { isAuth: true, },
    },


    //实习生招聘、校园招聘、社会招聘、内部招聘  列表
    {
      name: 'internship',
      path: '/internship',
      component: () => import('@/views/internship/index')
    }, {
      name: 'campus',
      path: '/campus',
      component: () => import('@/views/campus/index'),
    },
    {
      name: 'social',
      path: '/social',
      component: () => import('@/views/social/index')
    },
    {
      name: 'internal',
      path: '/internal',
      component: () => import('@/views/internal/index')
    },

    //实习生招聘、校园招聘、社会招聘、内部招聘  申请页面
    {
      name: 'internship_apply',
      path: '/internship/apply',
      component: () => import('@/views/Internship/apply'),
      meta: { isAuth: true, },
    },
    {
      name: 'campus_apply',
      path: '/campus/apply',
      component: () => import('@/views/Campus/apply'),
      meta: { isAuth: true, },
    },
    {
      name: 'social_apply',
      path: '/social/apply',
      component: () => import('@/views/Social/apply'),
      meta: { isAuth: true, },
    },
    {
      name: 'internal_apply',
      path: '/internal/apply',
      component: () => import('@/views/Internal/apply'),
      meta: { isAuth: true, },
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.isAuth) {     //判断是否需要鉴权
    // console.log(sessionStorage.getItem('user'));
    if (sessionStorage.getItem('user') && sessionStorage.getItem('user') != 'undefined') {
      next();
    } else {
      alert('请先登录!');
      next('/home')
    }
  } else {
    next()
  }
})

export default router






// WEBPACK FOOTER //
// ./src/router/index.js